import { render, staticRenderFns } from "./dietPlanSetting.vue?vue&type=template&id=5a0bea30&scoped=true&"
import script from "./dietPlanSetting.vue?vue&type=script&lang=js&"
export * from "./dietPlanSetting.vue?vue&type=script&lang=js&"
import style0 from "./dietPlanSetting.vue?vue&type=style&index=0&id=5a0bea30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0bea30",
  null
  
)

component.options.__file = "dietPlanSetting.vue"
export default component.exports